<template>
    <div>
        <modal-x :show="isSelectingImage" @onclose="isSelectingImage=false">
            <image-list v-if="isSelectingImage" :user-id="shopInfo.shopUserId" @onselect="onImgSelect"></image-list>
        </modal-x>
        <modal-x :show="isEditValidateJson" @onclose="isEditValidateJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-validator v-if="isEditValidateJson" :shop-user-id="shopInfo.shopUserId" @onsave="onJsonDataValidatorReturn" :init-data="initJsonData"></json-data-validator>
        </modal-x>
        <modal-x :show="isEditJson" @onclose="isEditJson=false" :content-style="{maxWidth:'800px'}">
            <json-data v-if="isEditJson" :shop-user-id="shopInfo.shopUserId" @onsave="onJsonReturn" :init-data="initJsonData"></json-data>
        </modal-x>
        <modal-x :show="isEditSlideJson" @onclose="isEditSlideJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-slide v-if="isEditSlideJson" :shop-user-id="shopInfo.shopUserId" @onsave="onSlideJsonReturn" :init-data="initJsonData"></json-data-slide>
        </modal-x>
        <modal-x :show="isEditLayoutJson" @onclose="isEditLayoutJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-layout v-if="isEditLayoutJson" :shop-user-id="shopInfo.shopUserId" @onsave="onLayoutJsonReturn" :init-data="initJsonData"></json-data-layout>
        </modal-x>
        <modal-x :show="isEditLawsJson" @onclose="isEditLawsJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-laws v-if="isEditLawsJson" :shop-user-id="shopInfo.shopUserId" @onsave="onLawsJsonReturn" :init-data="initJsonData"></json-data-laws>
        </modal-x>
        <modal-x :show="isEditLandingJson" @onclose="isEditLandingJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-landing v-if="isEditLandingJson" :shop-user-id="shopInfo.shopUserId" @onsave="onLandingJsonReturn" :init-data="initJsonData"></json-data-landing>
        </modal-x>

        <!-- Enhanced CSS with Bootstrap 3.3 classes -->
        <div class="label-entry-container">
            <div v-if="labelType==='_mobile_landing'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Mobile Landing Page</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>Target Page</label>
                            <select v-model="newLabel.label" class="form-control">
                                <option value="">Please Select</option>
                                <option value="/">Home Page</option>
                                <option value="/Account/Dashboard">Dashboard</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_landing'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Landing Page Configuration</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-4">
                            <div class="well well-sm">
                                <pre style="white-space: pre-wrap; word-wrap: break-word;">{{newLabel.text0}}</pre>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <label>Laws Title</label>
                            <div class="input-group">
                                <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter title">
                                <span class="input-group-btn">
                                    <button class="btn btn-primary" @click="isEditLandingJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}">Edit Json</button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_laws'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Laws Configuration</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-4">
                            <div class="well well-sm">
                                <pre style="white-space: pre-wrap; word-wrap: break-word;">{{newLabel.text0}}</pre>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <label>Laws Title</label>
                            <div class="input-group">
                                <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter title">
                                <span class="input-group-btn">
                                    <button class="btn btn-primary" @click="isEditLawsJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}">Edit Json</button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_layout'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Layout Theme Configuration</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-4">
                            <div class="well well-sm">
                                <pre style="white-space: pre-wrap; word-wrap: break-word;">{{newLabel.text0}}</pre>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <label>Theme Id</label>
                            <div class="input-group">
                                <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter theme ID">
                                <span class="input-group-btn">
                                    <button class="btn btn-primary" @click="isEditLayoutJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}">Edit Json</button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_pagedinfos'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Page Information</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-4">
                            <json-render :json-string="newLabel.text0" title-field="title"></json-render>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <label>Target Page</label>
                            <select v-model="newLabel.label" class="form-control">
                                <option value="">Please Select</option>
                                <option value="mobileIndex">Mobile Index Page</option>
                                <option value="index">Index Page</option>
                                <option value="listing">Listing Page</option>
                                <option value="product">Product Page</option>
                                <option value="article">Article Page</option>
                            </select>
                            <div class="margin-top-15">
                                <button class="btn btn-primary" @click="isEditJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}">Edit Json</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_validator'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Data Validation Configuration</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-4">
                            <json-render :json-string="newLabel.text0" title-field="title"></json-render>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <label>Target Data</label>
                            <select v-model="newLabel.label" class="form-control">
                                <option value="">Please Select</option>
                                <option value="product">Product</option>
                                <option value="article">Article</option>
                            </select>
                            <div class="margin-top-15">
                                <button class="btn btn-primary" @click="isEditValidateJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}">Edit Json</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_banner' || labelType==='_promo'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">{{ labelType === '_banner' ? 'Banner' : 'Promotional' }} Configuration</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-4 text-center">
                            <div class="thumbnail">
                                <img v-if="newLabel.frnImgPath!==null" style="max-width:150px;" :src="newLabel.frnImgPath" class="img-responsive" />
                                <div v-else class="placeholder-icon">
                                    <span class="glyphicon glyphicon-picture" style="font-size:50px;color:#ccc;"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <label>Image Name</label>
                            <div class="input-group">
                                <input class="form-control" type="text" v-model="newLabel.label" placeholder="Image filename">
                                <span class="input-group-btn">
                                    <button class="btn btn-primary" type="button" @click="selectImg(setNewLabelImg)">Select Image</button>
                                </span>
                            </div>
                            <label class="margin-top-15">Link URL</label>
                            <input class="form-control" type="text" v-model="newLabel.text1" placeholder="Enter link URL">
                            <div class="margin-top-15">
                                <button class="btn btn-primary" @click="isEditSlideJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}">Edit Json Content</button>
                            </div>
                            <div class="well well-sm margin-top-15">
                                <pre style="white-space: pre-wrap; word-wrap: break-word;">{{newLabel.text0}}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_address'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Address Information</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-4 text-center">
                            <div class="thumbnail">
                                <img v-if="newLabel.frnImgPath!==null" style="max-width:150px;" :src="newLabel.frnImgPath" class="img-responsive" />
                                <div v-else class="placeholder-icon">
                                    <span class="glyphicon glyphicon-map-marker" style="font-size:50px;color:#ccc;"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <label>Address Line 1</label>
                            <input class="form-control" type="text" v-model="newLabel.label" placeholder="Street/Unit">
                            <label class="margin-top-15">Address Line 2</label>
                            <input class="form-control" type="text" v-model="newLabel.text0" placeholder="City/State">
                            <label class="margin-top-15">Address Line 3</label>
                            <input class="form-control" type="text" v-model="newLabel.text1" placeholder="Zip/Country">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_news'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">News/Message Configuration</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>Type</label>
                            <select v-model="newLabel.label" class="form-control">
                                <option value="">Please Select</option>
                                <option value="0">Index Page Msg</option>
                                <option value="1">Item Page Msg</option>
                            </select>
                            <label class="margin-top-15">Title</label>
                            <input class="form-control" type="text" v-model="newLabel.text0" placeholder="Enter title">
                            <label class="margin-top-15">Content</label>
                            <textarea class="form-control" rows="4" v-model="newLabel.text1" placeholder="Enter content"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_whatsapp'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">WhatsApp Contact</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>WhatsApp Number</label>
                            <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter WhatsApp number">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_wechat'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">WeChat Contact</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>WeChat ID</label>
                            <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter WeChat ID">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_email'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Email Contact</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>Email Address</label>
                            <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter email address">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_phone'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Phone Contact</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>Phone Number</label>
                            <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter phone number">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_lang'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Language Setting</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>Language</label>
                            <select v-model="newLabel.label" class="form-control">
                                <option value="">Please Select</option>
                                <option value="english">English</option>
                                <option value="chinese">Chinese</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType === '_lang_backend'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Backend Language Setting</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>Backend Language</label>
                            <select v-model="newLabel.label" class="form-control">
                                <option value="">Please Select</option>
                                <option value="english">English</option>
                                <option value="chinese">Chinese</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="labelType==='_permit'" class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">Account Permissions</h4>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-md-8">
                            <label>Account Name</label>
                            <input class="form-control" type="text" v-model="newLabel.label" placeholder="Enter account name">
                            <label class="margin-top-15">Account User Id</label>
                            <input class="form-control" type="text" v-model="newLabel.text0" placeholder="Enter user ID">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jsonRender from './jsonRender.vue';
    import jsonData from './jsonData.vue';
    import jsonDataValidator from './jsonDataValidator.vue';
    import jsonDataSlide from './jsonDataSlide.vue';
    import jsonDataLayout from './jsonDataLayout.vue';
    import jsonDataLaws from './jsonDataLaws.vue';
    import jsonDataLanding from './jsonDataLanding.vue';
    import imageList from './imageList.vue';
    import modalX from '../components/base/ModalX1.vue';
    import apis from '../api/extApi.js';

    export default {
        components: {
            imageList: imageList,
            modalX: modalX,
            jsonRender: jsonRender,
            jsonData: jsonData,
            jsonDataValidator: jsonDataValidator,
            jsonDataSlide: jsonDataSlide,
            jsonDataLayout: jsonDataLayout,
            jsonDataLaws: jsonDataLaws,
            jsonDataLanding: jsonDataLanding
        },
        props: ["newLabel", "labelType", "shopInfo"],
        data: function () {
            return {
                apiClient: apis.api,
                uiClient: null,
                imgHandler: null,
                isSelectingImage: false,
                selectedImgs: [],
                isEditJson: false,
                isEditValidateJson: false,
                initJsonData: null,
                jsonHandler: null,
                isEditSlideJson: false,
                isEditLayoutJson: false,
                isEditLawsJson: false,
                isEditLandingJson: false
            };
        },
        methods: {
            onImgSelect: function (imgFile) {
                this.selectedImgs.push(imgFile);
                this.imgHandler(imgFile, this.selectedImgs);
            },
            setNewLabelImg: function (newImg) {
                this.newLabel.frnImgPath = newImg.thumbPath;
                this.newLabel.label = newImg.fileName + newImg.fileType;
                this.isSelectingImage = false;
            },
            selectImg: function (handler) {
                this.imgHandler = handler;
                this.isSelectingImage = !this.isSelectingImage;
            },
            onJsonReturn: function (ret) {
                this.isEditJson = false;
                console.log('ret onJsonReturn', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onJsonDataValidatorReturn: function (ret) {
                this.isEditValidateJson = false;
                console.log('ret onJsonReturn', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onSlideJsonReturn: function (ret) {
                this.isEditSlideJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onLayoutJsonReturn: function (ret) {
                this.isEditLayoutJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onLawsJsonReturn: function (ret) {
                this.isEditLawsJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onLandingJsonReturn: function (ret) {
                this.isEditLandingJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            }
        },
        created: function () {

        },
        mounted: function () {
            console.log("labelEntryTpl mounted", this.labelType, this.newLabel);
            this.uiClient = apis.ui.getShopClient({ userId: this.shopInfo.shopUserId });
        },
        destroyed: function () {
            this.uiClient.destroy();
            console.log("labelEntryTpl destroyed", this.labelType, this.newLabel);
        }
    }
</script>

<style scoped>
.label-entry-container {
    margin-bottom: 20px;
}
.panel-heading {
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
}
.panel-title {
    font-weight: bold;
}
.margin-top-15 {
    margin-top: 15px;
}
.thumbnail {
    padding: 10px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
}
.placeholder-icon {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 4px;
}
.well-sm {
    padding: 9px;
    background-color: #f9f9f9;
    border: 1px solid #e3e3e3;
}
.btn-primary {
    background-color: #337ab7;
    border-color: #2e6da4;
}
</style>